/**
 * Directive for table tbody: cells that contain only empty text (no child elements)
 * are displayed as "0" so tables show 0 instead of blank when there is no data.
 */
function setEmptyCellsToZero(el) {
    if (!el || el.tagName !== 'TBODY') return
    const tds = el.querySelectorAll('td')
    tds.forEach((td) => {
        if (td.children.length === 0 && td.textContent.trim() === '') {
            td.textContent = '0'
        }
    })
}

export default {
    inserted(el) {
        setEmptyCellsToZero(el)
    },
    componentUpdated(el) {
        setEmptyCellsToZero(el)
    }
}
